import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Divider, message, Button } from 'antd';
import cloneDeep from 'lodash.clonedeep';
import { getConfig, getServicesAdmin, getIsSavedServices, getIsSavingServices } from '../../../reducers';
import LoadingPage from '../../../components/LoadingPage';
import { storage } from '../../../config/Fire';
import { setConfig } from '../../../actions/setConfig';
import FormNewService from '../../../components/FormNewService';
import ServicesTableAdmin from '../../../components/tables/ServicesTableAdmin';
import { setServicesAdminToState } from '../../../actions/dataForState/setServicesAdminToState';
import { addServiceAdmin, setSavedServices } from '../../../actions/dataForState/addServiceAdmin';
import { removeServiceAdmin } from '../../../actions/dataForState/removeServiceAdmin';

function compareUid( a, b ) {
    const uidA = a.uid;
    const uidB = b.uid;
    if ( uidA < uidB ) {
      return -1;
    }
    if ( uidA > uidB ) {
      return 1;
    }
    return 0;
};

class ServicesAdmin extends Component {
    state = {
        types: {},
        fileService: [],
        serviceSelected: null,
        isLoadingIcon: false,
        fileIcons: [],
        areIconsLoaded: false,
        isAddSerice: false,
    }

    getIconsStorage = () => {
        const { config } = this.props;
        console.log("getIconsStorage")
        if(config.services && config.services.icons) {
            var fileIcons = [];
            return config.services.icons.forEach((element, index) => {
                return storage.ref().child(element).getDownloadURL().then(url => {
                    fileIcons.push({ uid: index, name: element, status: 'done', url: url });
                    if(fileIcons.length === config.services.icons.length) {
                        fileIcons.sort(compareUid);
                        this.setState({ fileIcons: fileIcons, areIconsLoaded: true });
                    }
                });
            });
        }
    }

    handleSubmitService = values => {
        const services = cloneDeep(this.props.services);
        var serviceAlreadyExist = false;
        for (var key in services) {
            var service = services[key];
            if(service.name && service.name === values.field_service) {
                serviceAlreadyExist = true;
            }
        }
        if(serviceAlreadyExist) {
            message.error('¡Ya existe un servicio con ese nombre!');
        } else {
            this.saveNewService(values);
        }
    }

    saveNewService = values => {
        const services = cloneDeep(this.props.services);
        var service = {
            name: values.field_service,
            icon: values.field_icon,
        }
        this.props.addServiceAdmin({ service, services });
    }

    renderSavedServices = () => {
        message.success('¡Los cambios se guardaron exitósamente!');
        var isSavedServices = false;
        this.props.setSavedServices(isSavedServices);
        return;
    }
    
    renderTableServices = services => {
        var data = [];
        for (var key in services) {
            var service = services[key];
            var isServiceWithIcon = false;
            // eslint-disable-next-line no-loop-func
            this.state.fileIcons.forEach(icon => {
                if(icon.name === service.icon) {
                    isServiceWithIcon = true;
                    data.push({ key: service.id, service: service.name, icon: icon, isLoading: this.props.isSavingServices });
                }
            });
            if(!isServiceWithIcon) {
                data.push({ key: service.id, service: service.name, icon: null, isLoading: this.props.isSavingServices });
            }
        }
        return (<ServicesTableAdmin data={data} onDeleteService={this.handleDeleteService}/>);
    }

    handleDeleteService = (record) => {
        if(record && record.key) {
            const services = cloneDeep(this.props.services);
            this.props.removeServiceAdmin({ key: record.key, services });
        }
    }

    isInfoLoaded = () => {
        const { services, config } = this.props;
        if(services && config) {
            return true;
        } else {
            return false;
        }
    }

    getInfo = () => {
        const { setServices, services, setConfig, config } = this.props;
        if(!services) {
            setServices();
        }
        if(!config) {
            setConfig();
        }
        return (<LoadingPage />);
    }

    render() {
        return (
            <div>
                {
                    this.isInfoLoaded() ?
                        <Grid>
                            <Row styles={{ float: 'left' }}>
                                <Col xs={6}>
                                    <Button onClick={this.props.onExitServices}>
                                        Volver
                                    </Button>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col>
                                    <h2>Servicios</h2>
                                </Col>
                            </Row>
                            {
                                this.state.fileIcons.length === 0 && this.getIconsStorage()
                            }
                            {
                                this.state.areIconsLoaded ?
                                    <div>
                                        <Divider>Agregar</Divider>
                                        {
                                            <Row center="xs">
                                                <Col>
                                                    <FormNewService isSaving={this.props.isSavingServices} isSavedServices={this.props.isSavedServices} fileIcons={this.state.fileIcons} onSubmit={this.handleSubmitService}/>
                                                </Col>
                                            </Row>
                                        }
                                        <Divider>Existentes</Divider>
                                        {
                                            this.renderTableServices(this.props.services)
                                        }
                                        {
                                            this.props.isSavedServices && this.renderSavedServices()
                                        }
                                    </div>
                                    :
                                    <LoadingPage />
                            }
                        </Grid>
                        :
                        this.getInfo()
                }
            </div>
        );
    }
}

ServicesAdmin.propTypes = {
    onExitServices: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setConfig: value => dispatch(setConfig(value)),
    setServices: value => dispatch(setServicesAdminToState(value)),
    addServiceAdmin: value => dispatch(addServiceAdmin(value)),
    removeServiceAdmin: value => dispatch(removeServiceAdmin(value)),
    setSavedServices: value => dispatch(setSavedServices(value)),
});

const mapStateToProps = state => ({
    services: getServicesAdmin(state),
    config: getConfig(state),
    isSavingServices: getIsSavingServices(state),
    isSavedServices: getIsSavedServices(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ServicesAdmin));